<script setup lang="ts">
import SpinnerIcon from '@assets/icons/spinner.svg?component';
import { AUTH_ROUTES, buildLoginUrl } from '@constants/auth-routes';
import { onMounted } from 'vue';

const loginWithQuery = (query: string) => {
  window.location.href = `${AUTH_ROUTES.LOGIN}?${query}`;
};

const redirectToSignIn = () => {
  window.location.href = buildLoginUrl();
};

onMounted(async () => {
  const searchParams = new URLSearchParams(window.location.search);
  const code = searchParams.get('code')?.trim() ?? '';
  const id = searchParams.get('id')?.trim() ?? '';

  if (!code || !id) {
    loginWithQuery('linkExpired=1');
    return;
  }

  try {
    const formData = new FormData();
    formData.set('uid', id);
    formData.set('code', code);
    formData.set('redirect', `${AUTH_ROUTES.LOGIN}?activated=1`);

    if (window.csrfTokenName && window.csrfTokenValue) {
      formData.set(window.csrfTokenName, window.csrfTokenValue);
    }

    // POST is required to actually activate; GET only renders verification form.
    const response = await fetch('/actions/users/verify-email', {
      method: 'POST',
      body: formData,
      credentials: 'same-origin',
    });

    const nextUrl = new URL(response.url, window.location.origin);
    const hasExpiredFlag = nextUrl.searchParams.get('linkExpired') === '1';

    if (hasExpiredFlag) {
      loginWithQuery('linkExpired=1');
      return;
    }

    loginWithQuery('activated=1');
  } catch {
    redirectToSignIn();
  }
});
</script>

<template>
  <div class="flex w-full flex-col items-center gap-16 py-40 text-center">
    <SpinnerIcon class="size-40 animate-spin text-off-black-500" />
    <h1 class="font-inter-tight text-26 font-semibold text-off-black-500">
      Activating your account
    </h1>
    <p class="text-14 text-off-black-500">
      Please wait while we verify your account.
    </p>
  </div>
</template>
